/** Paleta fija del legacy (las clases se guardan tal cual en la BD y la plataforma las pinta). */
export const FONDOS: Record<string, string> = {
  colorF_1: '#2981B0',
  colorF_2: '#6BBF4A',
  colorF_3: '#E28743',
  colorF_4: '#EAB676',
  colorF_5: '#76B5C5',
  colorF_6: '#21140D',
  colorF_7: '#873E22',
  colorF_8: '#ABDBE3',
  colorF_9: '#0F3970',
  colorF_10: '#35AB8E',
  colorF_11: '#B51800',
  colorF_12: '#24385B',
};

export const TEXTOS: Record<string, string> = {
  colorTt_1: '#FFFFFF',
  colorTt_2: '#CCCCCC',
  colorTt_3: '#999999',
  colorTt_4: '#666666',
  colorTt_5: '#333333',
  colorTt_6: '#000000',
};

export const FONDO_INICIAL = 'colorF_10';
export const TEXTO_INICIAL = 'colorTt_1';

/** Banderas de los bloques (E, R, BP, Rc), como las ve el alumno. */
export const BANDERAS = [
  ['hasEvidence', 'E', 'Evidencia'],
  ['hasRecommendation', 'R', 'Recomendación'],
  ['hasGoodPractice', 'BP', 'Buena práctica'],
  ['hasKeyRecommendation', 'Rc', 'Recomendación clave'],
] as const;
